import React from "react";
import { motion } from "framer-motion";
import { useLanguage } from "@/context/LanguageContext";
import { commonLabels } from "@/i18n";

interface RegionCardProps {
  region: {
    title: string;
    description: string;
    cities: string[];
    icon: string;
  };
  index: number;
}

const RegionCard = ({ region, index }: RegionCardProps) => {
  const { language } = useLanguage();
  const labels = commonLabels(language);
  const marketsLabel =
    labels.menuPages?.sellCar?.coverageSection?.marketsLabel ||
    "Viktiga Marknader:";
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ delay: index * 0.2, duration: 0.6 }}
      viewport={{ once: true }}
      className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300"
    >
      <div className="text-center mb-6">
        <div className="text-6xl mb-4">{region.icon}</div>
        <h3 className="text-2xl font-bold text-gray-900 mb-2">
          {region.title}
        </h3>
        <p className="text-gray-600">{region.description}</p>
      </div>

      <div className="mb-6">
        <h4 className="font-semibold text-gray-900 mb-3">{marketsLabel}</h4>
        <div className="flex flex-wrap gap-2">
          {region.cities.map((city, cityIndex) => (
            <span
              key={cityIndex}
              className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm"
            >
              {city}
            </span>
          ))}
        </div>
      </div>
    </motion.div>
  );
};

export default RegionCard;
